
import { Ticket } from "@/models/tickets/ticket";
import { TicketService } from "@/services/ticket-service";
import { ToolbarService } from "@/services/toolbar-service";
import Vue from "vue";
import AppTimeago from "@/components/common/Timeago.vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			tickets: [] as Ticket[],
			toggleAllTickets: false,
			ticketFilter: [1]
		};
	},
	props: {
		basePath: {
			type: String,
			default: "/support/tickets"
		},
		showDossier: Boolean
	},
	computed: {
		locale(): string {
			return this.$i18n.locale;
		},
		hideSubRoute(): boolean {
			if (this.$route.path == this.basePath || this.$route.path == "/support") {
				return true;
			}
			return false;
		},
		filteredTickets(): Ticket[] {
			return this.tickets.filter(t => this.toggleAllTickets ? t : [1, 2, 3, 6, 7].includes(t.statusId));
		},
		ticketFilterOptions(): ISelectItem<number>[] {
			return [
				{
					value: 1,
					text: "Openstaand"
				},
				{
					value: 2,
					text: "Afgehandeld"
				}
			];

		}
	},
	methods: {
		statusText(status: Number): string {
			return this.$ct("status." + status).toString();
		},
		statusClass(id: Number): string {
			return "status_" + id;
		},
		async update() {
			this.tickets = await TicketService.getTickets(true);
		}
	},
	async created() {
		this.tickets = await TicketService.getTickets();
	},
	mounted() {
		ToolbarService.title = this.$ct("tickets");
	},
	components: {
		AppTimeago
	},
	i18nEx: {
		componentPrefix: "components.tickets"
	}
});
